import React from "react";
import Modal from "./Modal";

export default function ConfirmModal(props) {
    var {title, text, body, onConfirm, onCancel, confirmTitle, dialogClassName} = props;

    // EN-21290: Support controlled mode (external open prop) or uncontrolled mode (internal state)
    const [internalOpen, setInternalOpen] = React.useState(false);
    const isControlled = props.open !== undefined;
    const open = isControlled ? props.open : internalOpen;

    const handleOpen = () => {
        if (!isControlled) {
            setInternalOpen(true);
        }
    };

    const handleConfirm = () => {
        onConfirm();
        if (!isControlled) {
            setInternalOpen(false);
        }
    }

    const handleClose = () => {
        if (!isControlled) {
            setInternalOpen(false);
        }
        if (onCancel) {
            onCancel();
        }
    };

    const getConfirmBody = () => {
        return (
            <div>

                <div className={"alertBody"}>
                    <h1 className={"alertTitle"}>{title}</h1>
                    <div className={"alertMessage"}>
                        {
                            body ? body : (<div>{text}</div>)
                        }
                    </div>
                </div>

                <div className={"alertActions dualActions"}>
                    <div onClick={handleClose}
                         className={"alertAction button action medium"}
                         role="button"
                         tabIndex={0}
                         onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClose(); } }}>
                        <div className={"buttonTitle"}>Cancel</div>
                    </div>

                    <div onClick={handleConfirm}
                         className={"alertAction button confirm medium"}
                         role="button"
                         tabIndex={0}
                         onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleConfirm(); } }}>
                        <div className={"buttonTitle"}>{confirmTitle}</div>
                    </div>
                </div>

            </div>
        )
    }

    return (
        <Modal
            button={(
            <div
                onClick={handleOpen}
                tabIndex={0}
                role="button"
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen(); } }}
            >
                {props.children}
            </div>
        )}
            content={getConfirmBody()}
            dialogClassName={dialogClassName ? `alertModal ${dialogClassName}` : "alertModal"}
            title={null}
            ariaLabel={title}
            size="xs"
            handleClose={handleClose}
            handleOpen={handleOpen}
            open={open}
        />
    )
}